import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLang } from '../../language/LanguageProvider.jsx';

const ProfileButton = styled(Link)`
  margin-right: 1rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  background: #829196;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: var(--second-color);
  }
`;

const ProfileButtonInMenu = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  font-size: 0.95rem;
  font-weight: 400;
  outline: none;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  &:focus {
    outline: none;
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
  }

  & > i {
    font-size: 1.1rem;
    width: 1.5rem;
    text-align: center;
  }

  @media (max-width: 900px) {
    font-size: 1.05rem;
    padding: 0.875rem 1.5rem;

    & > i {
      font-size: 1.2rem;
    }
  }
`;

const ProfileDropdown = ({ inMenu = false }) => {
  const { t } = useLang();

  if (inMenu) {
    return (
      <ProfileButtonInMenu to="/info/">
        <i className="fas fa-cog"></i>
        <span>{t('lateral.accountInfo')}</span>
      </ProfileButtonInMenu>
    );
  }

  return (
    <ProfileButton to="/info/" title={t('lateral.accountInfo')}>
      <i className="fas fa-cog"></i>
    </ProfileButton>
  );
};

export default ProfileDropdown;
